import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BaseApi, BASE_URL } from "@edl-development/edl-common";
import { DateTimeDTO } from "src/app/model/date-time-dto.model";
import { CreateObservationDTO } from "src/app/model/observation/diff/diff-create-dto.model";
import { ObservationSummaryDTO } from "src/app/model/observation/observation-summary-dto.model";
import { PerformanceMasterDTO } from "src/app/model/observation/spm/performance-master-dto.model";

@Injectable()
export class SpmApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getObservationDetails(spmId: string) {
        return this.http.get<PerformanceMasterDTO>(this.baseUri + '/observation/spm/' + spmId, {});
    }

    createSpm(createDto: CreateObservationDTO) {
        return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/spm/create', createDto);
    }

    scheduleInitialConference(spmId: string, date: DateTimeDTO) {
        return this.http.put(this.baseUri + '/observation/spm/' + spmId + '/scheduleInitialConference', date, {});
    }

    completeInitialConference(spmId: string, complete: boolean) {
        return this.http.put(this.baseUri + '/observation/spm/' + spmId + '/completeInitialConference', complete, {});
    }

    savePerformanceMaster(performanceMaster: PerformanceMasterDTO) {
        return this.http.put(this.baseUri + '/observation/spm/save', performanceMaster, {});
    }

    submitPerformanceMaster(performanceMaster: PerformanceMasterDTO, section: number) {
        return this.http.put(this.baseUri + '/observation/spm/submit/' + section, performanceMaster, {});
    }

    linkSignature(observationId: string, section: number) {
        return this.http.put(this.baseUri + '/observation/spm/' + observationId + '/linkSignature/' + section, {});
    }

    saveFinalRating(observationId: string, rating: number) {
        return this.http.put(this.baseUri + '/observation/spm/' + observationId + '/finalRating/' + rating, {});
    }

    notifyOfComment(observationId: string) {
        return this.http.put(this.baseUri + '/observation/spm/' + observationId + '/notify', {});
    }
}